import { RootState } from "@app/redux/root-reducer";

export const selectMyProfileState = (store: RootState) =>
  store.myProfileReducer.myProfile;

export const selectUserProfileState = (store: RootState) =>
  store.myProfileReducer.updateUserProfile;
